/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaCheckboxWithInputText from 'DesignSystem/TysiaCheckboxWithInputText/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/TimegridScheduleNote/BlockTimeCheckbox/Content",
  onChange,
  isSubmitting
  
}) {
let scheduleNoteIsBlockingTimeValueData = fromData.useDataValue({ viewPath,
context: 'schedule_note',
path: 'is_blocking_time',
})
let scheduleNoteIsBlockingTimeChangeData = fromData.useDataChange({ viewPath,
context: 'schedule_note',
path: 'is_blocking_time',
})
let scheduleNoteIsBlockingTimeIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'schedule_note',
})
  return (<React.Fragment
>
<TysiaCheckboxWithInputText
  viewPath={`${viewPath}/TysiaCheckboxWithInputText`}
 text="Block time on calendar"
 data="schedule_note.is_blocking_time"
 value={scheduleNoteIsBlockingTimeValueData}
 onChange={scheduleNoteIsBlockingTimeChangeData}
 disabled={scheduleNoteIsBlockingTimeIsSubmittingData}
/>
{children}
</React.Fragment>)
}